export default [
    {
        name: "InterbankTransferList",
        path: "banking/transfers/interbank",
        component: () => import("./views/InterbankTransferList.vue"),
        meta: {
            title: "Interbank Transfers",
            perms: "interbank_transfers",
            icon: "fa-solid fa-exchange-alt",
        },
    },
    {
        name: "InterbankTransferCreate",
        path: "banking/transfers/interbank/create",
        component: () => import("./views/InterbankTransferForm.vue"),
    },
    {
        name: "InterbankTransferUpdate",
        path: "banking/transfers/interbank/:transfer",
        component: () => import("./views/InterbankTransferForm.vue"),
    },

    {
        name: "BankAccountList",
        path: "banking/accounts",
        component: () => import("./views/BankAccountList.vue"),
        meta: {
            title: "Bank Accounts",
            perms: "finances",
            icon: "fa-solid fa-money-check",
        },
    },

    {
        name: "BankAccountCreate",
        path: "banking/accounts/create",
        component: () => import("./views/BankAccountForm.vue"),
    },
    {
        name: "BankAccountUpdate",
        path: "banking/accounts/:account",
        component: () => import("./views/BankAccountForm.vue"),
    },

    {
        name: "BankSummaryList",
        path: "banking/summaries",
        component: () => import("./views/BankSummaryList.vue"),
        meta: {
            title: "Bank Summaries",
            perms: "bank_summaries",
            icon: "fa-solid fa-calendar-days",
        },
    },
    {
        name: "BankSummaryCreate",
        path: "banking/summaries/create",
        component: () => import("./views/BankSummaryForm.vue"),
    },
    {
        name: "BankSummaryUpdate",
        path: "banking/summaries/:summary",
        component: () => import("./views/BankSummaryForm.vue"),
    },

    {
        name: "CardSummaryList",
        path: "banking/summaries/card",
        component: () => import("./views/CardSummaryList.vue"),
        meta: {
            title: "Card Summaries",
            perms: "bank_summaries",
            icon: "fa-solid fa-calendar-days",
        },
    },
    {
        name: "CardSummaryCreate",
        path: "banking/summaries/card/create",
        component: () => import("./views/CardSummaryForm.vue"),
    },
    {
        name: "CardSummaryUpdate",
        path: "banking/summaries/card/:summary",
        component: () => import("./views/CardSummaryForm.vue"),
    },
];
